export const LOAD = 'LOAD';
export const SELECT = 'SELECT';

export function load(list) {
  return {
    type: LOAD,
    data: list,
  };
}

export function select(selected) {
  return {
    type: SELECT,
    user: selected,
  };
}